import * as React from 'react'

import {
  Box,
  NumericMetric,
  Text,
  ValueChangeIndicator,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  approved: number
  approvedLastMonth: number
}

const MetricApprovedPromotions = ({ approved, approvedLastMonth }: Props) => {
  const monthlyChange = Math.round((100 * (approved - approvedLastMonth)) / approvedLastMonth)
  const absMonthlyChange = Math.abs(monthlyChange) || 0

  const Footer = (
    <>
      <Box paddingTop="s2">
        <ValueChangeIndicator change={monthlyChange} target="neutral" />
      </Box>
      <Text weight="medium" size="100" color="grey800">
        {approved - approvedLastMonth === 0
          ? i18n.t('insights.widgets.approved_promotions.no_change')
          : i18n.t('insights.widgets.approved_promotions.change', {
              monthlyChange: absMonthlyChange,
            })}
      </Text>
    </>
  )

  return (
    <NumericMetric
      title={i18n.tp('insights.widgets.approved_promotions.approved_counted', { count: approved })}
      value={approved}
      footer={approvedLastMonth !== 0 ? Footer : null}
    />
  )
}

export default MetricApprovedPromotions
